import React from 'react';
import MediaImage from './MediaImage';

type DiagonalFormulaImageProps = {
  leftImage: string;
  rightImage: string;
  alt: string;
  className?: string;
  imageClassName?: string;
  priority?: boolean;
  sizes?: string;
};

export default function DiagonalFormulaImage({
  leftImage,
  rightImage,
  alt,
  className = '',
  imageClassName = '',
  priority,
  sizes,
}: DiagonalFormulaImageProps) {
  return (
    <div className={`absolute inset-0 overflow-hidden bg-[#111722] ${className}`} role="img" aria-label={alt}>
      <div
        className="absolute inset-0"
        style={{ clipPath: 'polygon(0 0, 54.5% 0, 42.5% 100%, 0 100%)' }}
      >
        <MediaImage
          src={leftImage}
          alt=""
          aria-hidden="true"
          className={`h-full w-full object-cover ${imageClassName}`}
          priority={priority}
          sizes={sizes}
        />
      </div>
      <div
        className="absolute inset-0"
        style={{ clipPath: 'polygon(57.5% 0, 100% 0, 100% 100%, 45.5% 100%)' }}
      >
        <MediaImage
          src={rightImage}
          alt=""
          aria-hidden="true"
          className={`h-full w-full object-cover ${imageClassName}`}
          priority={priority}
          sizes={sizes}
        />
      </div>
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-yellow-400/95 shadow-[0_0_22px_rgba(250,204,21,0.35)]"
        style={{ clipPath: 'polygon(54.5% 0, 57.5% 0, 45.5% 100%, 42.5% 100%)' }}
      />
    </div>
  );
}
